import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PublicGuard } from '@s-services/public.guard';
import { AuthGuard } from '@s-services/auth.guard';

import { LoginComponent } from '@s-auth/login/login.component';
import { SignupComponent } from '@s-auth/signup/signup.component';
import { LogoutComponent } from '@s-auth/logout/logout.component';
import { NotVerifiedComponent } from '@s-layout/views/errors/not-verified/not-verified.component';
import { E404Component } from '@s-layout/views/errors/404/404.component';
import { AuthComponent } from '@s-auth/auth/auth.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [PublicGuard] },
  { path: 'signup', component: SignupComponent, canActivate: [PublicGuard] },
  { path: 'auth', component: AuthComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'konto-verifizieren', component: NotVerifiedComponent },
  { path: '', loadChildren: () => import('app/pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: '**', pathMatch: 'full', component: E404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
